module.exports = __webpack_public_path__ + "img/login_compute.b511961f.png";